import { GRAY_600, GRAY_900 } from 'constants/styling/upbrandingTheme'
import { Typography, inputBaseClasses } from '@mui/material'
import { changeLanguage, changeLocale } from 'redux/Individual/User/ChangeLocale'

import { Language } from 'translations/Language'
import LanguageIcon from '@mui/icons-material/Language'
import { MUIDropdown } from 'components/common/MUIDropdown'
import { MUIDropdownInput } from 'components/common/MUIDropdownInput/MUIDropdownInput.component'
import { MUIDropdownItem } from 'components/common/MUIDropdownItem'
import { coerceLanguage } from 'utils/localization'
import i18n from 'translations/i18n'
import { useAuth0 } from 'utils/auth'
import { useDispatch } from 'react-redux'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * @component LanguageDropdown displayed TopBar
 * @example <LanguageDropdown />
 */
export const LanguageDropdown: React.FC = () => {
  const { t } = useTranslation('topbar')
  const dispatch = useDispatch()
  const { isAuthenticated } = useAuth0()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const selectedLanguage = useMemo(() => coerceLanguage(i18n.language), [i18n.language])

  return (
    <MUIDropdown
      button={(isOpen, action) => (
        <MUIDropdownInput
          sx={{
            borderRadius: '4rem', // Rounded corners
            [`.${inputBaseClasses.root}`]: {
              flex: 1,
              width: '2rem', // Adjusted to fit the two letters of the language name
              marginRight: '-1.2rem' // Adjusted to make the dropdown more compact and rounded
            }
          }}
          value={selectedLanguage}
          onClick={action}
          customInputContent={
            <LanguageIcon sx={{ color: GRAY_600, fontSize: '1.8rem', alignSelf: 'center' }} />
          }
        />
      )}>
      {Object.values(Language)?.map(lang => {
        return (
          <MUIDropdownItem
            key={lang}
            onClick={() => {
              dispatch(changeLanguage(lang))
              if (!isAuthenticated) return
              dispatch(changeLocale(lang))
            }}
          >
            <Typography variant="text-md" fontWeight={400} color={GRAY_900}>
              {t(`language:${lang.toUpperCase()}`, lang)}
            </Typography>
          </MUIDropdownItem>
        )
      })}
    </MUIDropdown>
  )
}
